export default __webpack_public_path__ + "5c968f9cdf977398b41bed8faf40a4b0.ttf";